export default "__VITE_ASSET__B_4vvai7__$_?format=webp__"